import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './SelectAllCheckbox.scss'

export default class SelectAllCheckbox extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    value: PropTypes.bool,
    onChange: PropTypes.func,
    indeterminate: PropTypes.bool,
    input: PropTypes.object,
  }

  handleChange = () => {
    const { disabled, onChange, value, input, indeterminate } = this.props

    if (indeterminate) {
      // When indeterminate, clicking should select all
      if (input) {
        return input.onChange(true)
      } else {
        if (!disabled) {
          return onChange(true)
        }
      }

      return
    }

    // Normal toggle behavior
    if (input) {
      return input.onChange(!input.value)
    } else {
      if (!disabled) {
        return onChange(!value)
      }
    }
  }

  render() {
    const { disabled, value, input, indeterminate } = this.props
    const targetValue = input ? input.value : value

    return (
      <div
        role="checkbox"
        aria-checked={indeterminate ? 'mixed' : targetValue}
        tabIndex="-1"
        className={classNames('select-all-checkbox', {
          enabled: targetValue && !indeterminate,
          disabled,
          indeterminate,
        })}
        onClick={this.handleChange}
      >
        <span
          className={classNames({
            'icon icon-checkbox': targetValue && !indeterminate,
            'icon icon-checkbox-empty': !targetValue && !indeterminate,
            'icon icon-checkbox-indeterminate': indeterminate,
          })}
        />
      </div>
    )
  }
}
